import { onAndroidKbApp, onIOSKbApp } from '@/hooks/use-env'
import { wxShare } from '@/utils/wx'
import Vue from 'vue'

const triggerShareEvent = new Event('triggerShare')

//右上角显示分享
export function showShareWithCallback(_self, shareModel, callback) {
    wxShare({
        title: shareModel.title ? shareModel.title : '开吧分享', // 分享标题
        desc: shareModel.content ? shareModel.content : '开吧，开汽车上新生活！', // 分享描述
        link: shareModel.url ? shareModel.url : 'http://www.kaiba315.com.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareModel.imageUrl ? shareModel.imageUrl : 'https://static.kaiba315.com.cn/kaiba-logo.png', // 分享图标
    })

    // 暂时不知道是做啥的
    _self.$bridge.registerHandler('CommonRequest', function (data, rspCallback) {
        console.log('app.track.CommonRequest', shareModel)
        rspCallback({
            type: 12,
            data: shareModel,
        })
        callback()
    })

    // 安卓端就在一开始就触发commonShare,这里做一个安全锁,忽略2秒内第一个触发的commonShare
    function createCommonShareSafeLock() {
        let safeNumber = 1

        setTimeout(() => {
            safeNumber = 0
        }, 1500)

        /**
         * @param {() => void} handle
         */
        return function (handle) {
            onAndroidKbApp(() => {
                if (safeNumber-- <= 0) {
                    handle()
                }
            })
            onIOSKbApp(handle)
        }
    }

    const commonShareSafeLock = createCommonShareSafeLock()

    // 点击右上角...触发
    _self.$bridge.registerHandler('CommonShare', function (data, rspCallback) {
        commonShareSafeLock(() => {
            console.log('app.track.CommonShare', shareModel)
            window.dispatchEvent(triggerShareEvent)
        })

        if (callback != null) {
            setTimeout(() => {
                callback()
            }, 0)
        }
        rspCallback({
            type: 12,
            data: shareModel,
        })
    })
}

/**
 * 
 * 定义使用说明
 * @param {object} usage 
 * @param {string} usage.description 相关描述文案 
 */
export function definePermissionUsage(usage) {
    Vue.prototype.$bridge.registerHandler('getPermissionUsage', function (data, rspCallback) {
        // data为对象, permission: 'microphone'| 'camera' | 'location
        console.log('app.track.getPermissionUssage', usage)
        rspCallback(usage)
    })
}

/**
 *
 * @description 定义分享更多按钮状态
 * 
 * @param {object} params
 * @param {boolean} params.showMenu - 显示右上角菜单. 默认显示
 * @param {0|1|2} params.panelStyle - 显示分享面板布局, 0:正常显示. 1:只显示复制链接,浏览器打开相关. 2:只显示分享微信、QQ等. 默认 0
 */
export function defineShareModelState(params = {}) {
    jumpToLocalUserInfo(Vue.prototype, {}, function (response) {
        const data = JSON.parse(response)
        if (Number(data.vcode) < 70601) {
            return
        }

        commonJump(Vue.prototype, {
            tag: 'OpenActRequest',
            data: {
                type: 68,
                data: {
                    show: params.showMenu || true,
                    showActionMode: params.panelStyle || 0
                },
            },
        })
    })
}

//右上角显示分享
export function showShare(_self, shareModel, callback = () => {}) {
    showShareWithCallback(_self, shareModel, callback)
}
export function doShare(_self, shareModel) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 12,
            data: shareModel,
        },
    }
    commonJump(_self, options)
}

export function jumpToClose(_self) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: -1,
            data: {},
        },
    }
    commonJump(_self, options)
}

export function jumpToRefresh(_self, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 18,
            data: {},
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToShake(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 3,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToReward(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 10,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToUploadImage(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: data,
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToShare(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: data,
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToOpenRichEditor(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 13,
            data: data,
        },
        rspCall: (res) => {
            if (!rspCall) {
                return
            }

            if (typeof res === 'string') {
                return rspCall(res.replace(/\n/g, '\\n').replace(/\r/g, '\\r'))
            }

            return rspCall(res)
        },
    }
    commonJump(_self, options)
}

export function jumpToUserInfo(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: data,
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToComplaintListByTag(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: data,
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToCircle(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 23,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToScan(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: data,
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToToast(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 28,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToLoginInfo(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 31,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToPlayLocalAudio(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 33,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToPlayNetAudio(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 34,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToLocalUserInfo(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 35,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToRecordVideo(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 36,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToRecordAudio(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        audio_id: '1111',
        action: '1', // 1开始　2取消
        max_length: '120',
        data: {
            type: 37,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToShareWx(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 40,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToPay(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 41,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToLoginCallback(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 42,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToLoginRefresh(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 43,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToNewWebViewFromFloatView(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 50,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToKbSign(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 51,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToLogout(_self) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 52,
            data: {},
        },
    }
    commonJump(_self, options)
}

export function jumpToVerifyLoginType(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 53,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToRenewalToken(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 54,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToGetLocation(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 55,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToCheckUpdate(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 56,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

/**
 * 唤起新版分享页面
 * @param {*} _self
 * @param {object} data
 * @param {string} [data.title] - 标题
 * @param {string} [data.content] - 内容
 * @param {string} [data.url] - 链接
 * @param {string} [data.imageUrl] - 分享图片
 * @param {*} [rspCall]
 */
export function openShareModel(_self, data, rspCall) {
    console.log('app.track.openShareModel', data)
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 58,
            data: data,
        },
        rspCall: rspCall,
    }
    window.dispatchEvent(triggerShareEvent)
    commonJump(_self, options)
}

/**
 * 通知更新有赞商城绑定
 * @param {*} _self
 * @param {*} data
 * @param {*} rspCall
 */
export function jumpToUpdateYouzan(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 59,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

/**
 * 省宣埋点
 */
export function jumpToCollectUtil(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 60,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

/**
 * 快速分享
 * @param {any} _self
 * @param {object} data
 * @param {'wx'|'wxCircle'|'qq'|'qZone'|'sina'|'dingding'} data.shareMedia 分享媒体类型
 * @param {string} data.title
 * @param {string} [data.content]
 * @param {string} data.imageUrl
 * @param {string} data.url
 * @param {string} [data.qqUrl]
 * @param {object} [data.tmuTrack]
 * @param {any} rspCall
 */
export function quickShare(_self, data, rspCall) {
    console.log('app.track.quickShare', data)
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 61,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

/**
 *
 * @description 保存图片
 * @param {any} _self
 * @param {object} data
 * @param {string} data.imageUrl
 * @param {any} [rspCall]
 */
export function saveImage(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 62,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

/**
 *
 * @description 保存视频
 * @param {any} _self
 * @param {object} data
 * @param {string} data.videoUrl
 */
export function saveVideo(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 63,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

/**
 *
 * @description 设置网页标题
 */
export function setWebViewTitle(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 64,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

/**
 *
 * @description 设置APP缓存
 * @param {any} _self
 * @param {object} data
 * @param {string} data.key
 * @param {string} data.value
 * @param {int=} data.expireTime
 */
export function setAppCache(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 65,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

/**
 *
 * @description 取APP缓存
 * @param {any} _self
 * @param {object} data
 * @param {string} data.key
 */
export function getAppCache(_self, data, rspCall) {
    var options = {
        tag: 'OpenActRequest',
        data: {
            type: 66,
            data: data,
        },
        rspCall: rspCall,
    }
    commonJump(_self, options)
}

export function jumpToUserDetail(_self, userId) {
    var action = 'pageUserDetail'
    var actionParams = {
        id: userId,
    }
    _self.$bridge.callHandler(
        'OpenActRequest',
        {
            type: 1001,
            data: {
                action: action,
                actionParams: actionParams,
            },
        },
        function (response) {},
    )
}

/** 调用外部浏览器打开url */
export function openBrowser(_self, url) {
    _self.$bridge.callHandler(
        'OpenActRequest',
        {
            type: 1001,
            data: {
                action: 'pageOpenSystemBrowser',
                actionParams: {
                    url,
                },
            },
        },
        function (response) {},
    )
}

export function jumpForAction(_self, action, actionParams) {
    _self.$bridge.callHandler(
        'OpenActRequest',
        {
            type: 1001,
            data: {
                action: action,
                actionParams: actionParams,
            },
        },
        function (response) {},
    )
}

function commonJump(_self, options) {
    if (options == null || options === 'undefined') {
        throw new Error('params is empty')
    }
    options.data = options.data || {}
    options.tag = options.tag || 'OpenActRequest'
    _self.$bridge.callHandler(options.tag, options.data, function (response) {
        console.log('brideg => 回调结果', response)
        if (options.rspCall != null && options.rspCall != 'underfined') {
            options.rspCall(response)
        }
    })
}
